// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + (chunkId === 995 ? "view-requests" : chunkId) + "." + {"243":"0fe8a0ff","995":"a3fcf1f8"}[chunkId] + ".js";
};